import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import VendorOnboardingForm from "./components/VendorOnboardingForm.tsx";
import UserOnboardingForm from "./components/UserOnboardingForm.tsx";
import VendorPortal from "./components/VendorPortal.tsx";
import PublicInvoiceUpload from "./components/PublicInvoiceUpload.tsx";
import PrivacyPolicy from "./components/PrivacyPolicy.tsx";
import "./index.css";

// Simple routing based on pathname
const AppRouter = () => {
  const path = window.location.pathname;
  
  // Public privacy policy
  if (path === '/privacy') {
    return <PrivacyPolicy />;
  }

  // Public USER onboarding route (from SMS invitation for pumpers/managers)
  if (path.startsWith('/user/onboard/')) {
    const token = path.split('/user/onboard/')[1];
    return <UserOnboardingForm token={token} />;
  }

  // Public vendor onboarding route (from SMS invitation)
  if (path.startsWith('/vendor/onboard/')) {
    const token = path.split('/vendor/onboard/')[1];
    return <VendorOnboardingForm token={token} />;
  }
  
  // Public vendor portal for service tickets
  if (path.startsWith('/vendor/ticket/')) {
    const publicLink = path.split('/vendor/ticket/')[1];
    return <VendorPortal publicLink={publicLink} />;
  }
  
  // Public invoice upload for vendors
  if (path.startsWith('/vendor/invoice/')) {
    const ticketId = path.split('/vendor/invoice/')[1];
    return <PublicInvoiceUpload ticketId={ticketId} />;
  }
  
  // Default: Main app
  return <App />;
};

createRoot(document.getElementById("root")!).render(<AppRouter />);